module.exports = __webpack_public_path__ + "assets/img/b3.5b39d132.png";